// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getRoute(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "track_live_order") {
    return ;
  }
  if (match.tl) {
    return ;
  }
  var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
  var match$1 = Js_dict.get(urlParams, "booking_id");
  var match$2 = Js_dict.get(urlParams, "customer_uuid");
  if (match$1 === undefined) {
    return ErrorUtils$Catalyst.raiseError("TrackLiveTripRouteManager.res", "Invalid booking_id/customer_uuid", "");
  }
  if (match$2 === undefined) {
    return ErrorUtils$Catalyst.raiseError("TrackLiveTripRouteManager.res", "Invalid booking_id/customer_uuid", "");
  }
  var queryParams = url.search.split("&");
  var findCustomerUuid = queryParams.find(function (x) {
        var splitQueryParam = x.split("=");
        return Caml_array.get(splitQueryParam, 0) === "customer_uuid";
      });
  if (findCustomerUuid === undefined) {
    return {
            TAG: /* TrackLiveTrip */4,
            _0: match$1,
            _1: match$2
          };
  }
  var updated_customer_uuid = (
      findCustomerUuid === undefined ? undefined : Caml_option.some(findCustomerUuid)
    ).split("=");
  return {
          TAG: /* TrackLiveTrip */4,
          _0: match$1,
          _1: Caml_array.get(updated_customer_uuid, 1)
        };
}

var RouteManager = {
  getRoute: getRoute
};

export {
  RouteManager ,
  
}
/* No side effect */
